(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["twl-reviews"] && !Shopify.designMode) return;
  try {
    
  class TwlReviewsTrack extends HTMLElement {
    connectedCallback() {
      if (this.hasAttribute('data-controlled')) {
        this.controller?.abort();
        this.controller = new AbortController();
        this.closest('.twl-reviews').querySelectorAll('[data-review-direction]').forEach(button => {
          button.addEventListener('click', () => {
            const card = this.firstElementChild;
            if (!card) return;
            const gap = parseFloat(getComputedStyle(this).columnGap) || 16;
            this.scrollBy({left: Number(button.dataset.reviewDirection) * (card.getBoundingClientRect().width + gap), behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth'});
          }, {signal: this.controller.signal});
        });
        return;
      }

      // Desktop slider starts centered on the middle card so partial cards
      // peek on BOTH sides (infinite-strip look). Grid mode and mobile keep
      // their natural start position.
      if (this.classList.contains('twl-reviews__track--grid')) return;
      if (!window.matchMedia('(min-width: 750px)').matches) return;

      requestAnimationFrame(() => {
        const cards = this.children;
        if (cards.length < 2) return;
        const mid = cards[Math.floor(cards.length / 2)];
        if (!mid) return;
        const left = mid.offsetLeft - (this.clientWidth - mid.clientWidth) / 2;
        this.scrollLeft = Math.max(0, left);
      });
    }
  }

  if (!customElements.get('twl-reviews-track')) {
    customElements.define('twl-reviews-track', TwlReviewsTrack);
  }

  } catch(e) { console.error(e); }
})();
})();
